import http from '@/utils/request';

/**
 * 查询页面信息
 */
export const queryPageInfo = (params) => http.get({
  url: '/pageAnalyze/queryPageInfo',
  params,
});

/**
 * 查询页面事件
 */
export const queryPageEvent = (params) => http.get({
  url: '/pageAnalyze/queryPageEvent',
  params,
});

/**
 * 查询页面事件top
 */
export const queryPageEventTop = (params) => http.get({
  url: '/pageAnalyze/queryPageEventTop',
  params,
});

/**
 * 查询页面用户top
 */
export const queryPageUserTop = (params) => http.get({
  url: '/pageAnalyze/queryPageUserTop',
  params,
});

/**
 * 查询页面数量
 */
export const queryPageCount = (params) => http.get({
  url: '/pageAnalyze/queryPageCount',
  params,
});

/**
 * 查询页面数量趋势
 */
export const queryPageCountTendency = (params) => http.get({
  url: '/pageAnalyze/queryPageCountTendency',
  params,
});
